import TextField from "@mui/material/TextField/TextField";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import { useState } from "react";
import { CommentViewModel } from "../../../../../api/models/CommentViewModel";
import { LeadsService } from "../../../../../api/services/LeadsService";
import {
  AppButton,
  FormSection,
} from "../../../../../components/ui";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { LeadCommentRequest } from "../../../../../api/models/LeadCommentRequest";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { errorInstructions } from "../../shared/Constants";
import LeadSideRailPortal from "./LeadSideRailPortal";

const MySwal = withReactContent(Swal);

interface CommentsActionsProps {
  lowPlacement?: boolean;
  leadId?: number | null;
  comments?: Array<CommentViewModel> | null;
  isNewRequest?: boolean;
  hideActions?: boolean;
  onApprovalChange?: Function;
}

export default function CommentsTab(props: CommentsActionsProps) {
  const [commentMessage, setCommentMessage] = useState<string>("");

  const sendMessage = () => {
    if (!props.comments || props.comments.length === 0) {
      MySwal.fire({
        title: <strong>Confirm info request</strong>,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "No, go back",
        confirmButtonText: "Yes, send now",
        confirmButtonColor: "#ed633a",
        reverseButtons: true,
      })
        .then((result) => {
          if (result.isConfirmed && !!props.leadId) {
            if (props.onApprovalChange) {
              props.onApprovalChange(true);
            }
            LeadsService.postApiLeadsLeaveComment(props.leadId, {
              message: commentMessage,
              updateStatus: true,
            } as LeadCommentRequest);
          }
        })
        .catch(() => {
          MySwal.fire({
            icon: "error",
            title: <p className="title">Error sending message</p>,
            html: (
              <div className="alert-text">{errorInstructions}</div>
            ),
          });
        });
      return;
    }
    if (!!props.leadId) {
      LeadsService.postApiLeadsLeaveComment(props.leadId, {
        message: commentMessage,
        updateStatus: true,
      } as LeadCommentRequest)
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          MySwal.fire({
            icon: "error",
            title: <p className="title">Error sending message</p>,
            html: (
              <div className="alert-text">{errorInstructions}</div>
            ),
          });
        });
    }
  };

  const showPanel =
    (props.comments && props.comments.length > 0) || props.isNewRequest;

  if (!showPanel) {
    return null;
  }

  return (
    <LeadSideRailPortal>
      <FormSection
        className="lead-side-panel"
        title="Messages"
        subtitle="Conversation about this lead."
        icon={<ChatBubbleOutlineIcon />}
        collapsible
        defaultExpanded
      >
        {props.comments?.map((comment, index) => {
          dayjs.extend(utc);
          dayjs.extend(tz);
          const timeZone = dayjs.tz.guess();
          const createdDate = dayjs
            .utc(comment.createdAt)
            .tz(timeZone)
            .format("YYYY-DD-MM hh:mA");
          return (
            <div className="lead-comment-holder" key={`${comment.createdAt}-${index}`}>
              <div className="send-by">
                Sent by:{" "}
                {comment.isCurrentOwner ? "You" : comment.createdByName}
                {" at "}
                {createdDate}
              </div>
              <div>{comment.message}</div>
            </div>
          );
        })}
        {!props.hideActions && (
          <>
            <TextField
              required
              multiline
              fullWidth
              label="Message"
              variant="outlined"
              sx={{ mt: 1 }}
              value={commentMessage}
              inputProps={{ minLength: 10 }}
              onChange={(e) => setCommentMessage(e.target.value)}
            />
            <AppButton
              variant="contained"
              color="primary"
              className="full-btn"
              sx={{ mt: 1 }}
              onClick={() => sendMessage()}
            >
              Send message
            </AppButton>
          </>
        )}
      </FormSection>
    </LeadSideRailPortal>
  );
}
